<template>
  <div>
    <el-form-item label="服务配置：" class="width100">
      <el-select v-model="form.value" multiple placeholder="请选择服务配置（支持多选）">
        <el-option v-for="item in serviceOptions" :key="item" :label="item" :value="item"></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>
<script>
export default {
  props: ['form', 'bisicsInfo'],
  data() {
    return {
    }
  },
  created() {
  },
  computed: {
    serviceOptions() {
      let find = this.bisicsInfo.find(item => item.code === 'goods_services')
      let arr = find.content.cont ? find.content.cont.split(',') : []
      return arr
    },

  }
}
</script>

<style lang="scss" scoped>
.title-box {
  margin-bottom: 10px;
  margin-right: 24px;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 30px;
    &::before {
      content: '';
      position: absolute;
      left: 20px;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
</style>